import { Building2 } from 'lucide-react';
import { useStructureFilter, STRUCTURE_LABELS, STRUCTURE_SHORT, type StructureFilter } from '../structureContext';

/** Sélecteur global affiché dans le header du CRM */
export default function StructureSelector({ compact = false }: { compact?: boolean }) {
  const { filter, setFilter } = useStructureFilter();

  const options: Array<{ v: StructureFilter; label: string; short: string }> = [
    { v: 'all', label: 'Toutes structures', short: 'GLOBAL' },
    { v: 'cygnature', label: STRUCTURE_LABELS.cygnature, short: STRUCTURE_SHORT.cygnature },
    { v: 'suivez_vos_reves', label: STRUCTURE_LABELS.suivez_vos_reves, short: STRUCTURE_SHORT.suivez_vos_reves },
  ];

  return (
    <div className="flex items-center gap-1.5 bg-slate-900/80 border border-slate-800 rounded-lg p-0.5">
      {options.map((o) => {
        const active = filter === o.v;
        return (
          <button
            key={o.v}
            onClick={() => setFilter(o.v)}
            title={o.label}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] font-medium tracking-wide transition-colors ${
              active
                ? o.v === 'cygnature'
                  ? 'bg-amber-500/20 text-amber-300 border border-amber-500/40'
                  : o.v === 'suivez_vos_reves'
                  ? 'bg-violet-500/20 text-violet-300 border border-violet-500/40'
                  : 'bg-slate-700 text-slate-100 border border-slate-600'
                : 'text-slate-400 hover:text-slate-200 border border-transparent'
            }`}
          >
            <Building2 size={11} strokeWidth={1.5} />
            {compact ? o.short : o.label}
          </button>
        );
      })}
    </div>
  );
}

/** Petit badge à afficher à côté d'un item (prestation, devis, contrat…) */
export function StructureBadge({ code }: { code: 'cygnature' | 'suivez_vos_reves' | null | undefined }) {
  const c = code || 'cygnature';
  const cls =
    c === 'cygnature'
      ? 'bg-amber-500/15 text-amber-300 border-amber-500/30'
      : 'bg-violet-500/15 text-violet-300 border-violet-500/30';
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold tracking-wider border ${cls}`}>
      <Building2 size={9} strokeWidth={2} /> {STRUCTURE_SHORT[c]}
    </span>
  );
}
